// const login = () => import('../views/login.vue')
const login = () => import('../views/loginSJ.vue')
const myProfile = () => import('../views/myProfile.vue')
const password = () => import('../views/password.vue')
// const check = () => import('../views/password.vue')
const forgetword = () => import('../views/forgetword.vue')
const chooseTenant = () => import('../views/chooseTenant.vue')
const systemEnter = () => import('../views/systemEnter.vue')
const index = () => import('../views/index.vue')
const role = () => import('../views/system/role.vue')
const calibration = () => import('../views/system/calibration.vue')

const viewList = () => import('../views/system/viewList.vue')
const roleAdd = () => import('../views/system/roleAdd.vue')
const roleEdit = () => import('../views/system/roleEdit.vue')
const rolePermList = () => import('../views/system/rolePermList.vue')
const personList = () => import('../views/system/person/personList.vue')
const architectureTree = () => import('../views/system/architecture/architectureTree.vue')
const archiTreeDetail = () => import('../views/system/architecture/archiTreeDetail.vue')
const personAdd = () => import('../views/system/person/personAdd.vue')
const personEdit = () => import('../views/system/person/personEdit.vue')
const logout = () => import('../views/system/logout.vue')
const feedback = () => import('../views/system/feedback/feedback.vue')
const feedbackDetail = () => import('../views/system/feedback/feedbackDetail.vue')
const carousel = () => import('../views/system/carousel/carousel.vue')
const application = () => import('../views/system/applicationSetting/application.vue')
const stationScreenList = () => import('../views/system/stationScreen/stationScreenList.vue')
const stationScreenAdd = () => import('../views/system/stationScreen/stationScreenAdd.vue')
const stationScreenEdit = () => import('../views/system/stationScreen/stationScreenEdit.vue')
// 场所管理
const placeTree = () => import('../views/system/place/placeTree.vue')
const placeTreeDetail = () => import('../views/system/place/placeTreeDetail.vue')
// const addPlace = () => import('../views/system/place/addPlace.vue')
// 物业创建场所
const placeTreeMaster = () => import('../views/system/placeMaster/placeTree.vue')
const placeTreeDetailMaster = () => import('../views/system/placeMaster/placeTreeDetail.vue')
// const addPlaceMaster = () => import('../views/system/placeMaster/addPlace.vue')
// 租户管理
const tenancyList = () => import('../views/system/tenancy/tenancyList.vue')
const tenancyAdd = () => import('../views/system/tenancy/tenancyAdd.vue')
const tenancyEdit = () => import('../views/system/tenancy/tenancyEdit.vue')

const deviceList = () => import('../views/system/device/deviceList.vue')
const deployList = () => import('../views/system/device/deployList.vue')
const monitorList = () => import('../views/system/device/monitorList.vue')
// import abnormalStatistic from '../views/system/data/abnormalStatis
const routes = [
  { path: '/', redirect: '/index' },
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/logout',
    name: 'logout',
    component: logout
  },
  { path: '/myProfile', name: 'myprofile', component: myProfile },
  { path: '/password', name: 'password', component: password },

  { path: '/forgetword', name: 'forgetword', component: forgetword },
  { path: '/chooseTenant', name: 'chooseTenant', component: chooseTenant },
  { path: '/systemEnter', name: 'systemEnter', component: systemEnter },
  {
    path: '/index',
    name: 'index',
    // redirect: '/index/person/list',
    component: index,
    children: [
      {
        path: 'role',
        name: 'role',
        redirect: '/index/role/list',
        component: { template: '<div><router-view></router-view></div>' },
        children: [
          {
            path: 'list',
            name: 'roleList',
            chineseName: '角色列表',
            component: { template: '<router-view></router-view>' },
            children: [
              {
                path: '',
                name: 'roleList',
                chineseName: '角色列表',
                component: role
              }, {
                path: 'add',
                name: 'roleAdd',
                chineseName: '新增角色',
                component: roleAdd
              }, {
                path: 'detail',
                name: 'roleDetail',
                chineseName: '编辑角色',
                component: roleEdit
              }, {
                path: 'permList',
                name: 'rolepermList',
                chineseName: '授权列表',
                component: rolePermList
              }
            ]
          }
        ]
      },
      {
        path: 'person',
        name: 'person',
        redirect: '/index/person/list',
        component: { template: '<div><router-view></router-view></div>' },
        children: [
          {
            path: 'list',
            name: 'personList',
            chineseName: '人员列表',
            component: personList
          }, {
            path: 'add',
            name: 'personAdd',
            chineseName: '新增人员',
            component: personAdd
          }, {
            path: 'detail',
            name: 'personDetail',
            chineseName: '编辑人员',
            component: personEdit
          }
        ]
      },
      {
        path: 'organization',
        name: 'organization',
        redirect: '/index/organization/tree',
        component: { template: '<div><router-view></router-view></div>' },
        children: [
          {
            path: 'tree',
            name: 'organizationTree',
            chineseName: '组织结构',
            component: architectureTree,
            children: [
              {
                path: 'detail',
                name: 'detail',
                chineseName: '部门详情',
                component: archiTreeDetail
              }
            ]
          }
        ]
      },
      {
        path: 'place',
        name: 'place',
        redirect: '/index/place/list',
        chineseName: '场所管理',
        component: { template: '<div><router-view></router-view></div>' },
        children: [
          {
            path: 'masterList',
            name: 'masterList',
            redirect: '/index/place/masterList/tree',
            component: { template: '<router-view></router-view>' },
            children: [
              {
                path: 'tree',
                name: 'placeTree',
                chineseName: '物业创建场所',
                component: placeTreeMaster,
                children: [
                  {
                    path: 'detail',
                    name: 'detail',
                    chineseName: '场所详情',
                    component: placeTreeDetailMaster
                  }
                  // {
                  //   path: 'addPlace',
                  //   name: 'addPlace',
                  //   chineseName: '添加场所',
                  //   component: addPlaceMaster
                  // }
                ]
              }
            ]
          },
          {
            path: 'list',
            name: 'placeList',
            redirect: '/index/place/list/tree',
            component: { template: '<router-view></router-view>' },
            children: [
              {
                path: 'tree',
                name: 'placeTree',
                chineseName: '场所列表',
                component: placeTree,
                children: [
                  {
                    path: 'detail',
                    name: 'detail',
                    chineseName: '场所详情',
                    component: placeTreeDetail
                  }
                  // {
                  //   path: 'addPlace',
                  //   name: 'addPlace',
                  //   chineseName: '添加场所',
                  //   component: addPlace
                  // }
                ]
              }
            ]
          },
          {
            path: 'view',
            name: 'view',
            redirect: '/index/place/view/viewList',
            chineseName: '场所视图',
            component: { template: '<router-view></router-view>' },
            children: [
              {
                path: 'viewList',
                name: 'viewList',
                component: viewList,
                children: []
              }
            ]
          },
          {
            path: 'calibration',
            name: 'calibration',
            redirect: '/index/place/calibration/main',
            chineseName: '场所标定',
            component: { template: '<router-view></router-view>' },
            children: [
              {
                path: 'main',
                name: 'calibration',
                // chineseName: '场所标定',
                component: calibration,
                children: []
              }
            ]
          }
        ]
      },
      {
        path: 'device',
        name: 'device',
        redirect: '/index/device/deviceList',
        chineseName: '设备管理',
        component: { template: '<div><router-view></router-view></div>' },
        children: [
          {
            path: 'deviceList',
            name: 'deviceList',
            chineseName: '设备列表',
            component: deviceList
          },
          {
            path: 'deployList',
            name: 'deployList',
            chineseName: '设备部署',
            component: deployList
          },
          {
            path: 'monitorList',
            name: 'monitorList',
            chineseName: '设备监测',
            component: monitorList
          }
        ]
      },
      {
        path: 'tenancy',
        name: 'tenancy',
        redirect: '/index/tenancy/list',
        component: { template: '<div><router-view></router-view></div>' },
        children: [
          {
            path: 'list',
            name: 'tenancyList',
            chineseName: '租户列表',
            component: tenancyList
          }, {
            path: 'add',
            name: 'tenancyAdd',
            chineseName: '新增租户',
            component: tenancyAdd
          }, {
            path: 'detail',
            name: 'tenancyDetail',
            chineseName: '编辑租户',
            component: tenancyEdit
          }
        ]
      },
      {
        path: 'app',
        name: 'app',
        redirect: '/index/app/carousel',
        component: { template: '<div><router-view></router-view></div>' },
        children: [
          {
            path: 'feedback',
            name: 'feedback',
            chineseName: '用户反馈',
            redirect: '/index/app/feedback/list',
            component: { template: '<router-view></router-view>' }, // 嵌套的router-view不需要再包一层div，否则原本的内容页面变小
            children: [
              {
                path: 'list',
                name: 'feedbackList',
                chineseName: '反馈列表',
                component: feedback
              },
              {
                path: 'detail',
                name: 'feedbackDetail',
                chineseName: '反馈详情',
                component: feedbackDetail
              }
            ]
          },
          {
            path: 'carousel',
            name: 'carousel',
            chineseName: '轮播图设置',
            component: carousel
          },
          {
            path: 'settings',
            name: 'settings',
            chineseName: '应用设置',
            component: application
          }
          // ,
          // {
          //   path: 'abnormalStatistic',
          //   name: 'abnormalStatistic',
          //   chineseName: '异常统计',
          //   component: abnormalStatistic
          // },
          // {
          //   path: 'dataStatistic',
          //   name: 'dataStatistic',
          //   chineseName: '埋点统计',
          //   component: dataStatistic
          // }
        ]
      },
      {
        path: 'stationScreen',
        name: 'stationScreen',
        redirect: '/index/stationScreen/list',
        component: { template: '<div><router-view></router-view></div>' },
        children: [
          {
            path: 'list',
            name: 'stationScreenList',
            chineseName: '模板列表',
            component: stationScreenList
          },
          {
            path: 'add',
            name: 'stationScreenAdd',
            chineseName: '新增模板',
            component: stationScreenAdd
          },
          {
            path: 'detail',
            name: 'stationScreenDetail',
            chineseName: '编辑模板',
            component: stationScreenEdit
          }
        ]
      }
    ]
  },
  { path: '*', redirect: '/index' }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes/index.js